import React, { useContext, useRef, useEffect, useState } from "react";
import { motion } from "framer-motion";
import { MdOutlineCancel, MdOutlineShoppingCart } from "react-icons/md";
import HeaderTitle from "../HederTitle/HeaderTitle";
import axios from "axios";
import "../Videos/Videos.css";
import { ShopContext } from "../../Context/ShopContext";
import { backend_url } from "../../App";
import { FaVolumeMute, FaVolumeUp } from "react-icons/fa";
import { Link } from "react-router-dom";

const Videos = () => {
  const { addToCart } = useContext(ShopContext);
  const [selectedVideo, setSelectedVideo] = useState(null);
  const [selectedProduct, setSelectedProduct] = useState(
    selectedVideo?.productIds?.[0] || {}
  );
  const [videos, setVideos] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [positionIndexes, setPositionIndexes] = useState([0, 1, 2]);

  const [isMuted, setIsMuted] = useState(true);

  const toggleMute = () => {
    setIsMuted((prev) => !prev);
  };

  // Fetch videos from backend
  useEffect(() => {
    const fetchVideos = async () => {
      try {
        const res = await axios.get(`${backend_url}/api/browseVideos`);
        setVideos(res.data);
      } catch (error) {
        console.error("Error fetching videos:", error);
      }
    };

    fetchVideos();
  }, [selectedVideo]);

  // Lock body scroll when modal is open
  useEffect(() => {
    if (isModalOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
    return () => (document.body.style.overflow = "auto");
  }, [isModalOpen]);

  const handleVideoClick = (video) => {
    setSelectedVideo(video);

    // Reset selectedProduct to the first product of the new video
    setSelectedProduct(video.productIds?.[0] || {});

    const index = videos.findIndex((v) => v._id === video._id);
    setPositionIndexes([
      (index - 1 + videos.length) % videos.length,
      index,
      (index + 1) % videos.length,
    ]);

    setIsModalOpen(true);
  };

  // Handle next and back buttons for sliding
  // const handleNext = () => {
  //   setPositionIndexes((prevIndexes) =>
  //     prevIndexes.map((prevIndex) => (prevIndex + 1) % videos.length)
  //   );
  // };

  // const handleBack = () => {
  //   setPositionIndexes((prevIndexes) =>
  //     prevIndexes.map(
  //       (prevIndex) => (prevIndex - 1 + videos.length) % videos.length
  //     )
  //   );
  // };

  // Next
  const handleNext = () => {
    setPositionIndexes((prevIndexes) =>
      prevIndexes.map((prevIndex) => (prevIndex + 1) % videos.length)
    );
    const centerIndex = (positionIndexes[1] + 1) % videos.length;
    const newVideo = videos[centerIndex];
    setSelectedVideo(videos[centerIndex]);
    setSelectedProduct(newVideo.productIds?.[0] || {});
  };

  // Back
  const handleBack = () => {
    setPositionIndexes((prevIndexes) =>
      prevIndexes.map(
        (prevIndex) => (prevIndex - 1 + videos.length) % videos.length
      )
    );

    const centerIndex =
      (positionIndexes[1] - 1 + videos.length) % videos.length;
    const newVideo = videos[centerIndex];
    setSelectedVideo(videos[centerIndex]);
    setSelectedProduct(newVideo.productIds?.[0] || {});
  };

  const handleRelatedVideoClick = (clickedIndex) => {
    const newSelectedVideo = videos[clickedIndex];

    setSelectedVideo(newSelectedVideo);

    setPositionIndexes([
      (clickedIndex - 1 + videos.length) % videos.length,
      clickedIndex,
      (clickedIndex + 1) % videos.length,
    ]);
  };

  const positions = ["left", "center", "right"];

  const cardVariants = {
    center: { x: "0%", scale: 1, zIndex: 5 },
    left: { x: "-170%", scale: 0.8, zIndex: 3 },
    right: { x: "170%", scale: 0.8, zIndex: 3 },
  };

  const containerRef = useRef(null);
  const [isDragging, setIsDragging] = useState(false);
  const [startX, setStartX] = useState(0);
  const [scrollLeft, setScrollLeft] = useState(0);

  const handleMouseDown = (e) => {
    setIsDragging(true);
    setStartX(e.pageX - containerRef.current.offsetLeft);
    setScrollLeft(containerRef.current.scrollLeft);
    document.body.style.cursor = "grabbing"; // Change cursor for entire body
    document.body.style.userSelect = "none"; // Disable text selection during drag
  };

  const handleMouseUp = () => {
    setIsDragging(false);
    document.body.style.cursor = "";
    document.body.style.userSelect = "";
  };

  const handleMouseMove = (e) => {
    if (!isDragging) return;
    e.preventDefault();
    const x = e.pageX - containerRef.current.offsetLeft;
    const walk = (x - startX) * 3; // Faster drag
    containerRef.current.scrollLeft = scrollLeft - walk;
  };

  const handleTouchStart = (e) => {
    setIsDragging(true);
    setStartX(e.touches[0].pageX - containerRef.current.offsetLeft);
    setScrollLeft(containerRef.current.scrollLeft);
  };

  const handleTouchMove = (e) => {
    if (!isDragging) return;
    const x = e.touches[0].pageX - containerRef.current.offsetLeft;
    const walk = (x - startX) * 3;
    containerRef.current.scrollLeft = scrollLeft - walk;
  };

  const handleTouchEnd = () => {
    setIsDragging(false);
  };

  return (
    <>
      <h1>
        <HeaderTitle Header="Browse By Videos" />
      </h1>

      <div className="videos-container">
        {/* Video Cards */}

        <div
          ref={containerRef}
          onMouseDown={handleMouseDown}
          onMouseUp={handleMouseUp}
          onMouseLeave={handleMouseUp}
          onMouseMove={handleMouseMove}
          onTouchStart={handleTouchStart}
          onTouchMove={handleTouchMove}
          onTouchEnd={handleTouchEnd}
          className="relative w-80% overflow-hidden"
        >
          {/* <div className={`flex gap-4 py-2 w-max ${isDragging ? 'cursor-grabbing' : 'cursor-grab'}`}> */}
          <div
            className={`flex flex-col md:flex-row gap-4 py-2 w-full ${
              isDragging ? "cursor-grabbing" : "cursor-grab"
            }`}
          >
            {videos.map((video, index) => (
              <div
                key={index}
                onClick={(e) => {
                  // Prevent click if we were dragging
                  if (isDragging) {
                    e.preventDefault();
                    e.stopPropagation();
                    return;
                  }
                  handleVideoClick(video);
                }}
                className="flex-shrink-0 w-72 rounded-lg overflow-hidden shadow-md hover:shadow-lg transition-all duration-200 active:scale-95"
              >
                <video
                  preload="none"
                  loop
                  autoPlay
                  playsInline
                  muted
                  className="w-full h-96 object-cover"
                  src={`${video.videoUrl}`}
                />
                <div className="p-3 bg-white">
                  <p className="font-medium text-gray-900 truncate">
                    {video.productIds?.[0]?.name}
                  </p>
                  <div className="mt-1 text-sm flex items-center flex-wrap">
                    <span className="font-semibold text-gray-900">
                      ₹{calculateDiscountPrice(video)}
                    </span>
                    {video.productIds?.[0]?.old_price && (
                      <>
                        <span className="ml-2 text-gray-500 line-through">
                          ₹{video.productIds?.[0]?.old_price}
                        </span>
                        <span className="ml-1 text-green-600">
                          ({video.productIds?.[0]?.new_price}% OFF)
                        </span>
                      </>
                    )}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Video Modal */}
        {isModalOpen && selectedVideo && (
          <div className="fixed z-50 flex items-center justify-center bg-black h-screen w-screen top-0 overflow-hidden sm:overflow-hidden overflow-y-auto">
            {positionIndexes.map((index, i) => (
              <motion.div
                key={index}
                className={`shadow-lg absolute transition-all duration-100 ${
                  positions[i] === "center"
                    ? "bg-white w-full sm:w-[40%] h-full sm:h-[70%]"
                    : "bg-white w-[20%] h-[60%]"
                }`}
                initial="center"
                animate={positions[i]}
                variants={cardVariants}
                transition={{ duration: 0.5 }}
                onClick={() => handleRelatedVideoClick(index)}
              >
                {positions[i] === "center" ? (
                  <>
                    {/* Desktop View */}
                    <div className="hidden sm:flex flex-row h-full overflow-y-scroll">
                      {/* Left Side Video */}
                      <div className="relative w-1/2">
                        <video
                          className="h-full w-full object-fill"
                          src={`${selectedVideo.videoUrl}`}
                          autoPlay
                          loop
                          muted={isMuted}
                          playsInline
                        />
                        {/* <button
                          onClick={toggleMute}
                          className="absolute bottom-4 right-4 bg-black bg-opacity-50 p-2 rounded-full text-white"
                        >
                          {isMuted ? (
                            <FaVolumeMute size={20} />
                          ) : (
                            <FaVolumeUp size={20} />
                          )}
                        </button> */}
                      </div>

                      {/* Right Side Details */}
                      <span className="w-1/2 flex flex-col overflow-hidden">
                        <div className="h-[90%] p-3 space-y-2 flex flex-col">
                          <div className="flex flex-col">
                            <div
                              className="overflow-x-auto custom-scrollbar flex space-x-2"
                              style={{
                                WebkitOverflowScrolling: "touch",
                                scrollBehavior: "smooth",
                                scrollSnapType: "x mandatory",
                                paddingBottom: "3px",
                              }}
                            >
                              {selectedProduct?.images?.[0].length > 0 &&
                                selectedProduct.images
                                  .slice(0, 3)
                                  .map((img, index) => (
                                    <img
                                      crossOrigin="anonymous"
                                      key={index}
                                      src={img}
                                      alt={`selectedProduct-${index}`}
                                      className="w-[200px] h-[208px] object-cover cursor-pointer rounded"
                                    />
                                  ))}
                            </div>

                            {/* Product Details */}
                            <div className="mt-2">
                              <p className="video-title text-wrap">
                                {selectedProduct.name}
                              </p>
                              <p className="new-price text-[#7e1fe2] font-semibold">
                                ₹
                                {selectedProduct.old_price &&
                                  Math.round(
                                    (selectedProduct.old_price *
                                      (100 - selectedProduct.new_price)) /
                                      100
                                  )}
                                &nbsp;
                                <span className="old-price text-gray-400">
                                  ₹{selectedProduct.old_price}
                                </span>
                                <span className="discount text-[#7e1fe2] font-semibold">
                                  {` (${selectedProduct.new_price}% OFF)`}
                                </span>
                              </p>
                            </div>
                          </div>

                          {/* Related Products */}
                          <div className="flex flex-col flex-grow h-1/2 overflow-y-hidden custom-scrollbar">
                            <p className="text-[12px] font-semibold">
                              Related Products
                            </p>
                            <div className="flex gap-2 p-1 overflow-x-auto custom-scrollbar">
                              {selectedVideo.productIds?.map((product) => (
                                <img
                                  crossOrigin="anonymous"
                                  key={product._id}
                                  src={product.images?.[0]}
                                  alt={product.name}
                                  className="w-36 h-36 object-cover cursor-pointer rounded hover:scale-105 transition-all"
                                  onClick={() => {
                                    setSelectedProduct(product);
                                  }}
                                />
                              ))}
                            </div>
                          </div>
                        </div>

                        {/* Buttons */}
                        <div className="h-auto py-2 flex flex-col sm:flex-row shadow-lg justify-around items-center gap-2 sm:gap-4 p-2">
                          <Link
                            to={`/product/${selectedVideo.productIds?.[0].id}/${selectedVideo.productIds?.[0].name}`}
                          >
                            <button className="border border-black text-sm rounded-lg px-2 py-2 hover:scale-105 transition-all">
                              More Info
                            </button>
                          </Link>

                          <button
                            onClick={() => {
                              addToCart(selectedVideo.productIds?.[0].id);
                            }}
                            className="bg-green-500 text-white px-2 py-2 text-sm rounded-lg hover:scale-105 transition-all"
                          >
                            Add to Cart
                          </button>
                        </div>
                      </span>
                    </div>

                    {/* Mobile View Modal */}
                    {/* Mobile View */}
                    <div className="flex sm:hidden w-full h-screen justify-center items-center relative p-3 bg-white">
                      {/* Video Card */}
                      <div className="relative w-full h-full max-w-md rounded-2xl overflow-hidden border border-gray-300 shadow-lg">
                        {/* Video */}
                        <video
                          className="w-full h-full object-cover"
                          src={selectedVideo.videoUrl}
                          autoPlay
                          loop
                          muted={isMuted}
                          playsInline
                        />

                        {/* Mute Button */}
                        {/* <button
                          onClick={toggleMute}
                          className="absolute bottom-[135px] right-3 bg-black bg-opacity-50 p-2 rounded-full text-white shadow-md z-10"
                        >
                          {isMuted ? (
                            <FaVolumeMute size={20} />
                          ) : (
                            <FaVolumeUp size={20} />
                          )}
                        </button> */}

                        {/* Product Info Card (Overlayed at Bottom) */}
                        <div className="absolute bottom-0 left-0 right-0 bg-white bg-opacity-95 text-black p-4 rounded-t-2xl shadow-inner">
                          <p className="text-base font-semibold truncate">
                            {selectedProduct.name}
                          </p>
                          <p className="text-[#7e1fe2] font-semibold text-sm">
                            ₹
                            {selectedProduct.old_price &&
                              Math.round(
                                (selectedProduct.old_price *
                                  (100 - selectedProduct.new_price)) /
                                  100
                              )}
                            &nbsp;
                            <span className="text-gray-400 line-through">
                              ₹{selectedProduct.old_price}
                            </span>
                            <span className="text-[#7e1fe2] ml-1">
                              ({selectedProduct.new_price}% OFF)
                            </span>
                          </p>

                          {/* More Info Button */}
                          <Link
                           to={`/product/${selectedVideo.productIds?.[0].id}/${selectedVideo.productIds?.[0].name}`}
                          >
                            <button className="mt-3 w-full bg-[#7e1fe2] text-white font-semibold py-2 px-4 rounded-md shadow hover:scale-105 transition">
                              More Info
                            </button>
                          </Link>
                        </div>
                      </div>

                      {/* Close Button */}
                      <button
                        onClick={(e) => {
                          e.stopPropagation();
                          setIsModalOpen(false);
                        }}
                        className="absolute top-4 right-4 bg-white bg-opacity-60 text-black font-extrabold p-3 rounded-[50%] shadow-2xl hover:bg-opacity-100 transition-all width-10 h-10 flex items-center justify-center"
                      >
                        ✕
                      </button>
                    </div>
                  </>
                ) : (
                  // Side Cards
                  <div className="flex flex-col items-center h-full">
                    <video
                      className="h-full w-full rounded-lg object-cover cursor-pointer"
                      src={`${videos[index]?.videoUrl}`}
                      loop
                      playsInline
                      onClick={() => {
                        handleRelatedVideoClick(index);
                        setSelectedProduct(
                          videos[index]?.productIds?.[0] || {}
                        );
                      }}
                    />
                    <p className="text-white text-sm mt-2">
                      {videos[index]?.productIds?.[0]?.name}
                    </p>
                  </div>
                )}
              </motion.div>
            ))}

            {/* Navigation + Close Buttons */}
            <div>
              <button
                className="text-white absolute left-3 bg-indigo-400 rounded-md py-3 px-6 text-lg"
                onClick={(e) => {
                  e.stopPropagation();
                  handleBack();
                }}
              >
                ❮
              </button>
              <button
                className="text-white absolute right-3 bg-indigo-400 rounded-md py-3 px-6 text-lg"
                onClick={(e) => {
                  e.stopPropagation();
                  handleNext();
                }}
              >
                ❯
              </button>
              <p
                className="text-2xl text-white absolute top-3 right-4 cursor-pointer"
                onClick={(e) => {
                  e.stopPropagation();
                  setIsModalOpen(false);
                }}
              >
                ✕
              </p>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default Videos;

function calculateDiscountPrice(video) {
  if (!video.productIds?.[0]?.old_price) return "";
  return Math.round(
    (video.productIds[0].old_price * (100 - video.productIds[0].new_price)) /
      100
  );
}
